var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 7A5 5 0 112 7a5 5 0 0110 0zm-1.07 5.793a7 7 0 111.482-1.354l3.644 3.396a1 1 0 01-1.351 1.474l-3.774-3.516z","fill":"#FFF","fillRule":"evenodd"}));
}

Search.defaultProps = {"viewBox":"0 0 17 17"};

module.exports = Search;

Search.default = Search;
